import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Container, Tabs } from '@mui/material';
import LinkTab from 'components/common/LinkTab';
import { a11yProps } from 'components/mui/Tabs';
import Shippers from 'modules/companies/tables/Shippers';
import PortAgents from 'modules/companies/tables/PortAgents';
import TransportAgents from 'modules/companies/tables/TransportAgents';
import Parties from 'modules/companies/tables/Parties';
import VesselOwners from 'modules/companies/tables/VesselOwners';


const tabs = {
    shippers: () => <Shippers/>,
    port_agents: () => <PortAgents/>,
    transport_agents: () => <TransportAgents/>,
    parties: () => <Parties/>,
    vessel_owners: () => <VesselOwners/>,
};

const CompaniesInner = () => {
    const {t} = useTranslation();
    const { status = 'shippers' } = useParams();

    if (!(status in tabs)) {
        return null;
    }

    return (
        <Container maxWidth='xl' sx={{mt: 2}}>
            <Tabs
                variant="scrollable"
                value={status}
                aria-label="companies by type"
                sx={{mb:2}}
            >
                {Object.keys(tabs).map(tab => (
                    <LinkTab
                        key={tab}
                        value={tab}
                        label={t(tab)}
                        to={`/companies/${tab}`}
                        {...a11yProps('company-types', tab)}
                    />
                ))}
            </Tabs>

            {tabs[status as keyof typeof tabs]()}
        </Container>
    )
};

const Companies = () => {
    return (
        <Suspense fallback={null}>
            <CompaniesInner/>
        </Suspense>
    )
}

export default Companies;
